import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import JobPageLayout from 'components/layout/landing/JobPageLayout';
import JobsViewIndex from 'screens/LandingPages/Jobs/Detail';
import MainHead from 'components/layout/main/MainHead';
import { apiConfig } from 'utils/api/v2';
import { appHostProd } from 'utils/constants';
import config from 'utils/config';

type JobDetailProps = {
  data: any;
};

function PublicJobDetail({ data }: JobDetailProps) {
  const copData = data?.certificate?.cop?.join(', ');
  const isMainDomain = config.cookiesConfig.domain === appHostProd;

  return (
    <>
      <MainHead
        title={`${data?.company?.name || 'Company'} is hiring ${data?.rank || 'Position'} on ${data?.vessel_type || 'Vessel Type'} | OnBoard Crew App - Portal Kerja & Karier Pelaut`}
        description={`Min. ${data?.min_exp} tahun pengalaman, ${data?.certificate?.coc ? data?.certificate?.coc : ''}, ${copData ? copData : ''}. Lihat selengkapnya di aplikasi OnBoard.`}
        robots={isMainDomain ? 'index,follow' : 'noindex,nofollow,noarchive'}
        googleBot={isMainDomain ? 'index,follow' : 'noindex,nofollow,noarchive'}
      />
      <JobsViewIndex detail={data} />
    </>
  );
}

PublicJobDetail.getLayout = (page) => (
  <JobPageLayout type="jobDetail">{page}</JobPageLayout>
);

/**
 * Server-side render on every request.
 * Adds a “2-minute fresh, 1-minute stale” CDN cache hint
 * (works on Vercel and most CDNs that respect `s-maxage`).
 */

export const getServerSideProps: GetServerSideProps<JobDetailProps | undefined> = async ({
  locale = 'en',
  params,
  res,
}) => {
  const API_CONFIG = apiConfig();
  const baseUrl = process.env.NEXT_PUBLIC_BASE_API_V2;
  const jobId = params?.id;

  const response = await fetch(`${baseUrl}/api/v2/public/jobs/${jobId}`, {
    headers: {
      Authorization: `Bearer ${API_CONFIG.key}:${API_CONFIG.secret}`,
    },
  });

  if (!response.ok) {
    if (response.status === 404) {
      return { notFound: true };
    } else {
      throw new Error(`Failed to fetch job data: ${response.statusText}`);
    }
  }

  const data = await response.json();

  // Optional edge caching (s-maxage in seconds)
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=120, stale-while-revalidate=60'
  );

  return {
    props: {
      data,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default PublicJobDetail;
